"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("./utils");

var _InnerWrapper = _interopRequireDefault(require("./InnerWrapper"));

var _ArrowRight = _interopRequireDefault(require("./ArrowRight"));

var _ArrowLeft = _interopRequireDefault(require("./ArrowLeft"));

var _lodash = require("lodash");

var _jsxFileName = "E:\\720\\720yun_tour_player\\src\\components\\dxc-scroll-menu\\src\\ScrollMenu.js";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ScrollMenu = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(ScrollMenu, _React$PureComponent);

  function ScrollMenu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      mounted: false,
      initTranslate: 0,
      translate: 0,
      dragging: false,
      disabledRight: true,
      disabledLeft: true
    });

    _defineProperty(_assertThisInitialized(_this), "itemsRef", {});

    _defineProperty(_assertThisInitialized(_this), "menuWidth", 0);

    _defineProperty(_assertThisInitialized(_this), "itemsWidth", 0);

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      clearTimeout(_this.resizeTimeOut);
      _this.resizeTimeOut = setTimeout(function () {
        _this.setRef();

        _this.resize();
      }, 300);
    });

    _defineProperty(_assertThisInitialized(_this), "getPoint", function (ev) {
      if ("touches" in ev) {
        return ev.touches[0].clientX;
      } else if ("clientX" in ev) {
        return ev.clientX;
      } else {
        return 0;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
      var startDragTranslate = _this.state.translate;
      _this.startPoint = _this.getPoint(e);
      _this.startDragTranslate = startDragTranslate;
      _this.startDragTime = Date.now();
      _this.isInertia = false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
      if (!_this.startPoint) return;

      var point = _this.getPoint(e);

      var diff = point - _this.startPoint;

      if (Math.abs(diff) > 6) {
        _this.setState({
          dragging: true
        });
      }

      _this.setState({
        translate: _this.startDragTranslate + diff
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
      if (!_this.startPoint) return;
      var dragging = _this.state.dragging;
      _this.startPoint = false;
      if (!dragging) return;
      var translate = _this.state.translate;

      var speed = (_this.startDragTranslate - translate) / (Date.now() - _this.startDragTime);

      _this.isInertia = true;

      _this.inertia(Math.abs(speed) * 1.2, speed > 0 ? "right" : "left");
    });

    _defineProperty(_assertThisInitialized(_this), "inertia", function (speed, direction) {
      if (speed <= 0 || !_this.isInertia) {
        _this.inertiaStop();

        _this.setState({
          dragging: false
        });

        return;
      }

      var interval = 5;
      var translate = _this.state.translate;
      translate = direction === "right" ? translate - speed * interval : translate + speed * interval;

      _this.setState({
        translate: translate
      });

      _this.inertiaTimeout = setTimeout(function () {
        var resistance = 0.01;

        if (translate > _this.maxTranslate || _this.minTranslate > translate) {
          resistance = 0.3;
        }

        _this.inertia(speed - resistance, direction);
      }, interval);
    });

    _defineProperty(_assertThisInitialized(_this), "inertiaStop", function () {
      _this.isInertia = false;
      var translate = _this.state.translate;

      if (_this.state.translate > _this.maxTranslate) {
        translate = _this.maxTranslate;

        _this.setState({
          translate: translate,
          dragging: false
        });

        _this.calculateArrow(translate);
      } else if (_this.minTranslate > translate) {
        translate = _this.minTranslate;

        _this.setState({
          translate: translate,
          dragging: false
        });

        _this.calculateArrow(translate);
      }

      _this.setState({
        translate: translate,
        dragging: false
      });

      _this.calculateArrow(translate);
    });

    _defineProperty(_assertThisInitialized(_this), "calculateArrow", function (translate) {
      var disabledRight = translate <= _this.minTranslate;
      var disabledLeft = translate >= _this.maxTranslate;

      _this.setState({
        disabledRight: disabledRight,
        disabledLeft: disabledLeft
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleWheel", function (e) {
      if (e.deltaY < 0) {
        _this.handleArrowClick();
      } else {
        _this.handleArrowClick(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleArrowClick", function (left) {
      if (left === void 0) {
        left = true;
      }

      var firstItem = (0, _utils.getObjectFirstAttribute)(_this.itemsRef);
      if (!firstItem) return;

      if (_this.itemsWidth < _this.menuWidth) {
        return;
      }

      var itemWidth = firstItem.width;
      var diff = itemWidth > _this.menuWidth ? itemWidth : _this.menuWidth - itemWidth;
      var translate = _this.state.translate;
      var newTranslate = left ? translate + diff : translate - diff;
      newTranslate = Math.max(newTranslate, _this.minTranslate);
      newTranslate = Math.min(newTranslate, _this.maxTranslate);

      _this.setState({
        translate: newTranslate
      });

      _this.calculateArrow(newTranslate);
    });

    _defineProperty(_assertThisInitialized(_this), "setItemsWpRef", function (itemsWpRef) {
      _this.itemsWpRef = itemsWpRef;
    });

    _defineProperty(_assertThisInitialized(_this), "setItemRef", function (itemsRef, modifySource) {
      _this.itemsRef = itemsRef;

      if (modifySource === "selected") {
        _this.setRef(); // this.resize();

      } else {
        _this.setState({
          mounted: false
        }, function () {
          _this.setRef();

          _this.resize();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setMenuWrapperRef", function (menuWrapper) {
      _this.menuWrapper = menuWrapper;
    });

    _defineProperty(_assertThisInitialized(_this), "setRef", function () {
      var _getClientRect = (0, _utils.getClientRect)(_this.menuWrapper),
          menuWidth = _getClientRect.width;

      if (menuWidth === 0) return;
      var itemsWidth = 0;
      var offset = 0;
      var refArr = (0, _lodash.orderBy)(_this.itemsRef, ["index"]);

      for (var i = 0; i < refArr.length; i++) {
        var key = refArr[i].key;
        var item = _this.itemsRef[key];
        item.width = item.ref.scrollWidth;
        item.offset = offset + parseInt((menuWidth - item.width) / 2);
        itemsWidth += item.width;
        offset -= item.width;
      }

      _this.menuWidth = menuWidth;
      _this.itemsWidth = _this.itemsWpRef.scrollWidth;
    });

    _defineProperty(_assertThisInitialized(_this), "resize", function () {
      var selected = _this.findSelectedRef();

      var translate = 0;

      if (_this.itemsWidth < _this.menuWidth) {
        var horizontal = _this.props.horizontal;

        if (horizontal === "left") {
          translate = 0;
        } else {
          translate = parseInt((_this.menuWidth - _this.itemsWidth) / 2);
        }

        _this.minTranslate = translate;
        _this.maxTranslate = translate;
      } else if (!selected) {
        _this.minTranslate = _this.menuWidth - _this.itemsWidth;
        _this.maxTranslate = 0;
      } else {
        _this.minTranslate = _this.menuWidth - _this.itemsWidth;
        _this.maxTranslate = 0;
        translate = selected.offset;
        translate = Math.max(translate, _this.minTranslate);
        translate = Math.min(translate, _this.maxTranslate);
      }

      _this.setState({
        initTranslate: translate,
        translate: translate
      });

      _this.calculateArrow(translate);

      setTimeout(function () {
        _this.setState({
          mounted: true
        });
      }, 10);
    });

    _defineProperty(_assertThisInitialized(_this), "findSelectedRef", function () {
      var selected = _this.props.selected;
      if (!selected || selected === "") return false;

      for (var key in _this.itemsRef) {
        if (key == selected) {
          return _this.itemsRef[key];
        }
      }

      return false;
    });

    return _this;
  }

  var _proto = ScrollMenu.prototype;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener("mousemove", this.handleDrag);
    document.addEventListener("mouseup", this.handleDragStop);
    window.addEventListener("resize", this.onResize);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener("mousemove", this.handleDrag);
    document.removeEventListener("mouseup", this.handleDragStop);
    window.removeEventListener("resize", this.onResize);
    clearTimeout(this.inertiaTimeout);
    clearTimeout(this.resizeTimeOut);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this$props = this.props,
        data = _this$props.data,
        selected = _this$props.selected,
        selectedChangeResize = _this$props.selectedChangeResize;
    var nextData = nextProps.data,
        nextSelected = nextProps.selected;

    if (data !== nextData) {
      this.setState({
        mounted: false
      });
    }

    if (selectedChangeResize && selected !== nextSelected) {
      this.onResize();
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        data = _this$props2.data,
        renderItem = _this$props2.renderItem,
        arrowRight = _this$props2.arrowRight,
        arrowLeft = _this$props2.arrowLeft,
        selected = _this$props2.selected,
        itemData = _this$props2.itemData;
    var _this$state = this.state,
        translate = _this$state.translate,
        dragging = _this$state.dragging,
        mounted = _this$state.mounted,
        disabledLeft = _this$state.disabledLeft,
        disabledRight = _this$state.disabledRight;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 230,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react["default"].createElement(_ArrowLeft["default"], {
      arrowLeft: arrowLeft,
      disabledLeft: disabledLeft,
      onClick: this.handleArrowClick.bind(this, true),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 231,
        columnNumber: 9
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.setMenuWrapperRef,
      onWheel: this.handleWheel,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 232,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        overflow: "hidden"
      },
      onMouseDown: this.handleDragStart,
      onTouchStart: this.handleDragStart,
      onTouchEnd: this.handleDragStop // onMouseMove={this.handleDrag}
      ,
      onTouchMove: this.handleDrag,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 233,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react["default"].createElement(_InnerWrapper["default"], {
      itemData: itemData,
      selected: selected,
      mounted: mounted,
      dragging: dragging,
      translate: translate,
      setItemRef: this.setItemRef,
      setItemsWpRef: this.setItemsWpRef,
      data: data,
      renderItem: renderItem,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 241,
        columnNumber: 13
      }
    }))), /*#__PURE__*/_react["default"].createElement(_ArrowRight["default"], {
      arrowRight: arrowRight,
      disabledRight: disabledRight,
      onClick: this.handleArrowClick.bind(this, false),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 254,
        columnNumber: 9
      }
    }));
  };

  return ScrollMenu;
}(_react["default"].PureComponent);

var _default = ScrollMenu;
exports["default"] = _default;
module.exports = exports.default;